import React from 'react';

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div 
      className="d-flex justify-content-center align-items-center" 
      style={{ 
        minHeight: "100vh", 
        backgroundColor: "#e6f0fa",
        flexDirection: "column"
      }}
    >
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status" style={{ width: "3rem", height: "3rem" }}>
          <span className="visually-hidden">Loading...</span>
        </div>
        <h4 className="text-muted">{message}</h4>
        <p className="text-muted small">Please wait while we verify your session...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
